/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_subjects_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `V mé objednávce chybí produkt.`
};

const da_contact_subjects_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Jeg mangler et produkt i min ordre.`
};

const de_contact_subjects_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Ein Produkt fehlt in meiner Bestellung.`
};

const en_contact_subjects_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `A product is missing from my order.`
};

const es_contact_subjects_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Falta un producto en mi pedido.`
};

const fr_contact_subjects_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Il me manque un produit dans ma commande.`
};

const hu_contact_subjects_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Hiányzik egy termék a rendelésemből.`
};

const it_contact_subjects_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Manca un prodotto nel mio ordine.`
};

const nl_contact_subjects_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Er ontbreekt een product in mijn bestelling.`
};

const pl_contact_subjects_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Brakuje produktu w moim zamówieniu.`
};

const pt_contact_subjects_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `Falta um produto no meu pedido.`
};

const sv_contact_subjects_missing_product = /** @type {(inputs: {}) => string} */ () => {
	return `En produkt saknas i min beställning.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_subjects_missing_product = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_subjects_missing_product(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_subjects_missing_product", locale)
	if (locale === "cs") return cs_contact_subjects_missing_product(inputs)
	if (locale === "da") return da_contact_subjects_missing_product(inputs)
	if (locale === "de") return de_contact_subjects_missing_product(inputs)
	if (locale === "en") return en_contact_subjects_missing_product(inputs)
	if (locale === "es") return es_contact_subjects_missing_product(inputs)
	if (locale === "fr") return fr_contact_subjects_missing_product(inputs)
	if (locale === "hu") return hu_contact_subjects_missing_product(inputs)
	if (locale === "it") return it_contact_subjects_missing_product(inputs)
	if (locale === "nl") return nl_contact_subjects_missing_product(inputs)
	if (locale === "pl") return pl_contact_subjects_missing_product(inputs)
	if (locale === "pt") return pt_contact_subjects_missing_product(inputs)
	return sv_contact_subjects_missing_product(inputs)
};
export { contact_subjects_missing_product as "contact.subjects.missing_product" }